import { storeName } from './types';

const _getProductRTS = state => getState(state).productRTS || {};
const _getCartRTS = state => getState(state).cartRTS || {};

const getState = state => state[storeName] || [];
const getExpandedCardId = state => getState(state).expandedStockInfoCardId;
const getStores = state => getState(state).stores || [];
const getProductStores = state => _getProductRTS(state).stores || [];
const getCartStores = state => _getCartRTS(state).stores || [];
const getCartStoresErrorType = state => getState(state).storeErrorType || '';
const getStoreDisplayMsg = state => _getProductRTS(state).displayMessage || '';
const getRtsErrorMessage = state => getState(state).rtsErrorMessage || '';
const getStoreByIndex = (state, i) => getStores(state)[i] || {};
const getStoreByName = (state, name) => getStores(state).find(store => store.name === name) || {};

const getRtsProduct = state => _getProductRTS(state).product || {};
const getRtsProductCode = state => getRtsProduct(state).code || '';
const getRtsProductRangeName = state => getRtsProduct(state).rangeName || '';
const getProductQty = state => getState(state).quantity || 1;
const getLastStoreData = state => getState(state).lastStoreData;
const getLastStoreIsUsed = state => getState(state).lastStoreIsUsed;
const getLastStoreName = state => getState(state).storeName;
const getToggledStockInfoList = state => getState(state).toggledStockInfoList;
const getPdpUrl = state => state.minipdp.details.url;
const getPdtQuantity = state => state.minipdp.quantity || 0;
const getInStockInLastStore = state => getState(state).inStockInLastStore;
const getInputValue = state => getState(state).inputValue;
const getExpressDeliveryMode = state => getState(state).deliveryInformation || {};

export default {
    getState,
    getExpandedCardId,
    getStores,
    getStoreByIndex,
    getStoreByName,
    getRtsProduct,
    getRtsProductCode,
    getRtsProductRangeName,
    getCartStores,
    getProductStores,
    getProductQty,
    getLastStoreData,
    getLastStoreIsUsed,
    getToggledStockInfoList,
    getCartStoresErrorType,
    getStoreDisplayMsg,
    getLastStoreName,
    getPdpUrl,
    getPdtQuantity,
    getInStockInLastStore,
    getInputValue,
    getRtsErrorMessage,
    getExpressDeliveryMode,
};
